import styled from "styled-components";

export const Container = styled.div`
  width: 80%;
  height: 100%;
  background: #eef3f9;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  position: relative;

  .emojis {
    position: absolute;
    font-size: 2.4rem;
    width: 6rem;
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.5);
    cursor: pointer;

    .emojis-options {
      cursor: initial;
      width: 30rem;
      height: 20rem;
      padding: 1rem;
      bottom: 5rem;
      border-radius: 5px;
      position: absolute;
      background: #fff;
      -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
      display: none;
      flex-direction: row;
      flex-wrap: wrap;
      color: rgba(0, 0, 0, 1);
      align-items: space-between;
      justify-content: space-between;

      & > span {
        cursor: pointer;
      }
    }

    &:hover {
      .emojis-options {
        display: flex;
      }
    }
  }

  .load-container {
    padding: 2rem;
    width: 100%;
    height: calc(100% - 8.9rem - 10rem);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ul {
    padding: 2rem;
    list-style: none;
    width: 100%;
    height: calc(100% - 8.9rem - 10rem);
    overflow-y: scroll;

    li {
      margin-bottom: 1rem;

      &.carregar-mais {
        display: flex;
        justify-content: center;

        span {
          font-size: 1.3rem;
          padding: 1rem 2rem;
          background: #ffffff;
          border-radius: 20px;
          font-weight: 500;
          -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
          -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }
      }

      p {
        padding: 1rem 2rem;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 50px;
        display: inline-block;
        font-size: 1.4rem;
        position: relative;

        .icon-read {
          display: none;
        }
      }

      small {
        display: block;
        margin-top: 0.5rem;
        color: rgba(0, 0, 0, 0.6);
        font-size: 1.2rem;
      }

      &.my-message {
        text-align: right;

        p {
          background: rgba(255, 255, 255, 0.8);

          .icon-read {
            display: block;
          }

          &.readed {
            .icon-read {
              color: #18b7fa;
            }
          }

          .icon-read {
            position: absolute;
            right: -5px;
            bottom: -3px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }

      &.divider {
        text-align: center;
        padding: 1rem;
        font-size: 1.2rem;

        span {
          padding: 1rem;
          background: #fff;
          border-radius: 5px;
          -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          -moz-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  form {
    height: 10rem;
    width: 100%;
    padding: 2rem;

    & > div {
      display: flex;
      align-items: center;
      height: 100%;
      position: relative;

      input[type="text"] {
        width: 100%;
        height: 100%;
        padding: 1rem 6rem;
        border-radius: 10px;
        border: thin solid rgba(255, 255, 255, 0.5);
        text-transform: none !important;
        box-shadow: none !important;

        ::-webkit-input-placeholder {
          text-transform: none !important;
        }
        ::-moz-placeholder {
          text-transform: none !important;
        }
        :-ms-input-placeholder {
          text-transform: none !important;
        }
        :-moz-placeholder {
          text-transform: none !important;
        }
      }

      button {
        position: absolute;
        right: 2rem;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        border: 0;
        background-color: #d8faec;
        color: #0f715e;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 1.8rem;
        }
      }
    }
  }
`;

export const Head = styled.div`
  padding: 1.75rem;
  align-items: center;
  display: flex;
  width: 100%;
  background: #ffffff;
  border-bottom: thin solid rgba(255, 255, 255, 0.5);

  p {
    font-weight: 600;
    margin-left: 1rem;
    display: flex;
    flex-direction: column;

    small {
      color: rgba(0, 0, 0, 0.6);
      font-style: italic;
    }
  }
`;

export const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background-color: #f0f0f0;
  border-radius: 50%;
  overflow: hidden;

  img {
    max-width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ChatContainer/Chat/styles.js